export interface Weighting {
  totalVolumesSum: number;
  positions?: MyPosition[];
  remainingVolumesSum?: number;
  volumesPerAssetType?: VolumesPerAssetType;
}

interface MyPosition {
  isin: string;
  assetName: string;
  assetType: string;
  volume: number;
}

interface VolumesPerAssetType {
  FONDS: number;
  ETF: number;
  DERIVAT: number;
  AKTIE: number;
  KRYPTO: number;
}

export enum WeightingType {
  ASSETS,
  TOP_POSITIONS,
  ALL_POSITIONS,
}

export interface LegendPaging {
  items: number;
  from: number;
  to: number;
  current: number;
}

export interface AssetLabel {
  name: string;
  color: string;
}
